
export default {
    tickets: {},
    isTicketSubmitting: false,
    isTicketNegotiating: false,
    activeTicket: null,
    submitErrors: [],
    areTicketsLoading: false,
    ticketNegotiation: null,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/tickets/state.ts